import React from 'react';

const Loading = ({ loading, size }) => {
  if (!loading) return null;

  const loaderStyle = size ? { width: size, height: size } : {};

  return (
    <div className="loading-data sweet-loading">
      <div className="small active" style={loaderStyle}>
        <span className="loader" />
      </div>
    </div>
  );
};

export default Loading;
